import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import React from 'react'
import { LoginButtonEntityInterface } from 'src/shared/entities/login-button/login-button-entity.schema'
import { CommonEditorButtonEntityOrSubEntity } from '../../components/button/common-editor-button-entity-or-sub-entity'

export interface LoginButtonProps {
  entity: LoginButtonEntityInterface
  isMoveUpAllowed: boolean
  isMoveDownAllowed: boolean
}

export const LoginButton = ({
  entity,
  isMoveUpAllowed,
  isMoveDownAllowed,
}: LoginButtonProps) => {
  return (
    <BaseEntityNew
      entity={entity}
      flex
      flexColumn
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
    >
      <CommonEditorButtonEntityOrSubEntity
        entityOrSubEntity={entity}
      ></CommonEditorButtonEntityOrSubEntity>
    </BaseEntityNew>
  )
}
